import {
  GET_PAYROLLCOMPONENTDETAIL,
  GET_PAYROLLCOMPONENTDETAIL_SUCCESS,
  GET_PAYROLLCOMPONENTDETAIL_FAIL,
  DELETE_PAYROLLCOMPONENTDETAIL,
  DELETE_PAYROLLCOMPONENTDETAIL_SUCCESS,
  DELETE_PAYROLLCOMPONENTDETAIL_FAIL,
  UPDATE_PAYROLLCOMPONENTDETAIL,
  UPDATE_PAYROLLCOMPONENTDETAIL_SUCCESS,
  UPDATE_PAYROLLCOMPONENTDETAIL_FAIL,
  ADD_NEW_PAYROLLCOMPONENTDETAIL,
  ADD_PAYROLLCOMPONENTDETAIL_SUCCESS,
  ADD_PAYROLLCOMPONENTDETAIL_FAIL,
  PAYROLLCOMPONENTDETAIL_LOADING,
  PAYROLLCOMPONENTDETAIL_RESET,
} from "./actionType";

export const resetPayrollComponentDetailState = (actionType) => ({
  type: PAYROLLCOMPONENTDETAIL_RESET,
  payload: { actionType },
});

export const getPayrollComponentDetailSuccess = (actionType, data) => ({
  type: GET_PAYROLLCOMPONENTDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getPayrollComponentDetailFail = (actionType, error) => ({
  type: GET_PAYROLLCOMPONENTDETAIL_FAIL,
  payload: { actionType, error },
});

export const getPayrollComponentDetail = data => ({
  type: GET_PAYROLLCOMPONENTDETAIL,
  payload: data,
});

export const getPayrollComponentDetailLoading = () => ({
  type: PAYROLLCOMPONENTDETAIL_LOADING
});

export const deletePayrollComponentDetail = data => ({
  type: DELETE_PAYROLLCOMPONENTDETAIL,
  payload: data,
});

export const deletePayrollComponentDetailSuccess = data => ({
  type: DELETE_PAYROLLCOMPONENTDETAIL_SUCCESS,
  payload: data,
});

export const deletePayrollComponentDetailFail = error => ({
  type: DELETE_PAYROLLCOMPONENTDETAIL_FAIL,
  payload: error,
});

export const updatePayrollComponentDetail = data => ({
  type: UPDATE_PAYROLLCOMPONENTDETAIL,
  payload: data,
});

export const updatePayrollComponentDetailFail = error => ({
  type: UPDATE_PAYROLLCOMPONENTDETAIL_FAIL,
  payload: error,
});

export const updatePayrollComponentDetailSuccess = data => ({
  type: UPDATE_PAYROLLCOMPONENTDETAIL_SUCCESS,
  payload: data,
});

export const addNewPayrollComponentDetail = data => ({
  type: ADD_NEW_PAYROLLCOMPONENTDETAIL,
  payload: data,
});

export const addPayrollComponentDetailSuccess = data => ({
  type: ADD_PAYROLLCOMPONENTDETAIL_SUCCESS,
  payload: data,
});

export const addPayrollComponentDetailFail = error => ({
  type: ADD_PAYROLLCOMPONENTDETAIL_FAIL,
  payload: error,
});